import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import svg5 from "../../../assets/svg/svg5.svg";

function Cards() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "menu/water_harvesting_dashboard";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const svgMap = {
    svg5,
  };
  const processedData = data?.map((item) => ({
    ...item,
    svg: svgMap[item?.dymIcon],
  }));

  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-5">
     {/* <div className="flex flex-shrink flex-wrap  gap-y-[1rem] gap-x-[1rem] mt-[1.25rem]"> */}
      {processedData &&
        processedData?.map((item) => (
          <div className="rounded-[.75rem] border border-[#D6E1F5] bg-[#F7F7F7] h-[6.25rem] lg:w-[17.75rem] w-full p-[.5rem]">
            <div className="flex items-center justify-between">
              <div className="scheme-card-title">{item?.dymLabel}</div>
              <img src={item?.svg} alt={item?.svg} />
            </div>
            <div
              className={`scheme-card-content mt-[1.62rem] ${
                item?.dymCode == 0 && "!text-[#DD2222]"
              }`}
            >
              {item?.dymCode}
            </div>
          </div>
        ))}
    </div>
  );
}

export default Cards;
